import React from 'react';
import { object, string, func, bool } from 'prop-types';
import { StringConstantsMixin } from '../../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import SelectDropdown from '../../../forms/SelectDropdown';
import Toggle from '../../../shared/Toggle';
import RoutingTip from './RoutingTip';
import { routingControls, controlContainer, routingToggle, routingDropdown } from './styles/styles.module.scss';

const RouteControls = ({ routingMode, onSelectRoutingMode, routingActive, toggleRouting, closeRoutingTip, showRoutingTips, nodeSelected }) => {
  const routeModeStrings = StringConstantsMixin.strings.TRACK_DETAIL.ROUTE_MODES;
  const routingModes = ['hiking', 'mountain-biking', 'bike-touring', 'road-biking', 'off-road-driving', 'scenic-driving'];
  const routingOptions = routingModes.map(mode => ({ value: mode, label: routeModeStrings[mode.replace(/-/g, '_').toUpperCase()] }));
  const currentOption = routingOptions.find(option => option.value === routingMode);

  let tipType;

  if (nodeSelected) {
    tipType = 'NODE_TIP';
  } else if (routingActive) {
    tipType = 'SMART_TIP';
  } else {
    tipType = 'DRAW_TIP';
  }

  return (
    <div className={controlContainer}>
      <div className={routingControls}>
        <Toggle
          className={routingToggle}
          inputId="routeControlToggle"
          label={StringConstantsMixin.strings.TRACK_DETAIL.ROUTING_TIPS.SMART_ROUTING_LABEL}
          checked={routingActive}
          onChange={toggleRouting}
        />
        <SelectDropdown
          className={routingDropdown}
          id="routing-type-select"
          handleChange={onSelectRoutingMode}
          options={routingOptions}
          defaultItem={currentOption}
        />
      </div>
      {showRoutingTips && showRoutingTips[tipType] && <RoutingTip tipType={tipType} onClose={closeRoutingTip} />}
    </div>
  );
};

export default RouteControls;

RouteControls.propTypes = {
  closeRoutingTip: func.isRequired,
  nodeSelected: object,
  onSelectRoutingMode: func.isRequired,
  routingMode: string.isRequired,
  routingActive: bool.isRequired,
  showRoutingTips: object,
  toggleRouting: func.isRequired
};

RouteControls.defaultProps = {
  nodeSelected: null,
  showRoutingTips: null
};
